import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconColumnWideHalf: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="column-wide-half" maskId="round-filled-radius-0-stroke-1.5-IconColumnWideHalf"><path d="M2 4.75C2 4.33579 2.33579 4 2.75 4H21.25C21.6642 4 22 4.33579 22 4.75V11.25H2V4.75Z" fill="currentColor"/><path d="M2 12.75V19.25C2 19.6642 2.33579 20 2.75 20H21.25C21.6642 20 22 19.6642 22 19.25V12.75H2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconColumnWideHalf;
